import { render } from "./ProjectCheckoutButton.vue?vue&type=template&id=8a1d5388"
import script from "./ProjectCheckoutButton.vue?vue&type=script&lang=js"
export * from "./ProjectCheckoutButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__